import React, { PropsWithChildren } from 'react';
import { MediaLibProvider } from '../../toolympus/components/medialib';



export const MediaLibProviderX = (props: PropsWithChildren<{}>) => {
  return (
    <MediaLibProvider
      apiPath="/api/media"
      spaceId="documentation"
      protectedFiles
      getFilepath={mf => `/api/media/${mf.space_id}/${mf._id}`}>
      {props.children}
    </MediaLibProvider>
  );
}
